import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import useKidListFunctionality from "../../../../customHooks/kidListHook";
import {
  videoNudityMonitor,
  defaultParameter,
} from "../../../AxiosRtk/SetRules";
import useFirebase from "../../../../../useFirebase";
import { isEmpty } from "lodash";
import CommonStatus from "../../Common/CommonStatus";
import useDeviceStatus from "../../../../customHooks/deviceStatusProvider";
import useLangTranslation from "../../../../customHooks/languageProvider";
import { setShowMessage } from "../../../AxiosRtk/successMessage";
import Select from "react-select";
import KidImage from "../../../../shared/KidImage/KidImage";

const DefaultSettings = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [kid, setKid] = useState(null);
  const [device, setDevice] = useState("");
  const { getLangTranslation } = useLangTranslation();
  const [loader, setLoader] = useState(false);

  const [deviceStatus, setDeviceStatus] = useState("");
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );
  const [defaultSettings, setDefaultSetting] = useState({});
  // console.log(defaultSettings)
  const [defaultParameterData, setDefaultParameterData] = useState([
    {
      id: Math.floor(Math.random() * Math.pow(10, 6)),
      key: "IsGeoLocationEnabled",
      endcodedKey: "DEFAULT_SETTINGS_GEOLOCATION_ENABLED",
      text: "Geolocation enabled",
      value: 0,
    },
    {
      id: Math.floor(Math.random() * Math.pow(10, 6)),
      key: "IsKeystrokeEndabled",
      endcodedKey: "DEFAULT_SETTINGS_KEYSTROKE_MONITORING",
      text: "Keystrokes monitoring enabled",
      value: 0,
    },
    {
      id: Math.floor(Math.random() * Math.pow(10, 6)),
      key: "IsNudityAlertEnabled",
      endcodedKey: "SETUP_WIZARD_ENABLE_DEFAULT_NUDITY",
      text: "Nudity monitoring enabled",
      value: 0,
    },
    {
      id: Math.floor(Math.random() * Math.pow(10, 6)),
      key: "IsVideoMonitoringEnabled",
      endcodedKey: "DEFAULT_SETTINGS_VIDEO_MONITORING_ENABLED",
      text: "Videos monitoring enabled",
      value: 0,
    },
    {
      id: Math.floor(Math.random() * Math.pow(10, 6)),
      key: "IsCallAndSMSEnabled",
      endcodedKey: "DEFAULT_SETTINGS_CALL_SMS_MONITORING_ENABLED",
      text: "Call and SMS monitoring enabled",
      value: 0,
    },
    {
      id: Math.floor(Math.random() * Math.pow(10, 6)),
      key: "IsSettingBlock",
      endcodedKey: "DEFAULT_SETTINGS_APP_BLOCKED",
      text: "Settings app will be blocked",
      value: 0,
    },
    {
      id: Math.floor(Math.random() * Math.pow(10, 6)),
      key: "IsSetDeviceTimeEnabled",
      endcodedKey: "DEFAULT_SETTINGS_DEVICE_TIME_SUPERVISION_ENABLED",
      text: "Device time supervision enabled",
      value: 0,
    },
    {
      id: Math.floor(Math.random() * Math.pow(10, 6)),
      key: "IsSafeSearchEnabled",
      endcodedKey: "DEFAULT_SETTINGS_SAFE_SEARCH_ENABLED_WEB_YOUTUBE",
      text: "Safe Search enabled on web and YouTube",
      value: 0,
    },
    {
      id: Math.floor(Math.random() * Math.pow(10, 6)),
      key: "SetDeviceTimeSlots",
      endcodedKey: "DEFAULT_SETTINGS_ALLOWED_TIME",
      text: "Allowed time (24 hours format): ",
      value: [],
    },
    {
      id: Math.floor(Math.random() * Math.pow(10, 6)),
      key: "IsKeystrokeEndabled",
      endcodedKey: "DEFAULT_SETTINGS_KEYSTROKE_MONITORING",
      text: "Keystrokes monitoring enabled",
      value: 0,
    },
    {
      id: Math.floor(Math.random() * Math.pow(10, 6)),
      key: "category",
      endcodedKey: "DEFAULT_SETTINGS_FOLLOWING_WEB_CATEGORY_WILL_BE_BLOCKED",
      text: "The following web categories will be blocked:",
      value: [],
    },
    {
      id: Math.floor(Math.random() * Math.pow(10, 6)),
      key: "AppCategory",
      endcodedKey: "DEFAULT_SETTINGS_FOLLOWING_APP_CATEGORY_WILL_BE_BLOCKED",
      text: "The following apps categories will be blocked:",
      value: [],
    },
  ]);
  // const [defaultParameter, setDefaultParameter]

  // console.log(defaultParameterData)
  const [deviceOptions, setDeviceOptions] = useState([]);

  const { setRulesData } = useSelector(({ setRules }) => setRules);

  const {
    postCollectionData,
    createCollectionData,
    getCollectionData,
    getDefaultSettingData,
  } = useFirebase();

  function callFirebase(payload) {
    if (setRulesData) {
      postCollectionData(selectedDeviceData?.ID, payload);
    } else {
      createCollectionData(selectedDeviceData?.ID, payload);
    }
    getCollectionData(selectedDeviceData?.ID);
  }

  const { getImage } = useKidListFunctionality();
  const { kidList, selectedKidId, kidDevicesList, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);

  useEffect(() => {
    if (kidList && selectedKidId) {
      const kid = kidList?.find(
        (item) => parseInt(item?.ID) === parseInt(selectedKidId)
      );
      setKid(kid);
    }
  }, [kidList, selectedKidId]);

  useEffect(() => {
    if (selectedDeviceData) {
      const jsonDevice = JSON.parse(selectedDeviceData?.ID);
      setDevice(jsonDevice?.ID);
    }
  }, [selectedDeviceData]);

  useEffect(() => {
    if (selectedDeviceData?.ID) {
      getDeviceStatusData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData?.ID]);

  function adjustDasyOfSchedule(schedule) {
    schedule = schedule?.map((item) => {
      item.day = item?.day?.toLowerCase()
      return item;
    })

    return schedule;
  }

  function handleDefaultSettingToggle(e) {
    setLoader(true);
    let collectionPayload = {
      loadDefaultSettings: e.target.checked ? 1 : 0,
    };
    const keyValuePairs = {
      enableSupervision: defaultSettings.enableSupervision,
      setRulesActiveInActiveStatus: {
        ...setRulesData?.setRulesActiveInActiveStatus,
        timeSupervisionEnabled: defaultSettings.timeSupervisionEnabled,
        appMonitoringEnabled: defaultSettings.isAppMonitoringEnabled,
        webMonitoringEnabled: defaultSettings.isWebMonitoringEnabled,
        callsAndSMSMonitoringEnabled:
          defaultSettings.callsAndSMSMonitoringEnabled,
        videoMonitoringEnabled: defaultSettings.videoMonitoringEnabled,
        nudityAndImageCategorizationEnabled:
          defaultSettings.nudityMonitoringEnable,
        locationAndGeofencingEnable: defaultSettings.geoLocationEnable,
        keysrtrokesMonitoringEnabled: defaultSettings.enableKeyStroke === 1,
      },
      webmonitoring: {
        ...setRulesData?.webmonitoring,
        safeSearchYoutube: defaultSettings.safeSearchYoutube,
        enforceSafeSearchYoutube: defaultSettings.enforceSafeSearchYoutube,
        enforceSafeSearchBing: defaultSettings.enforceSafeSearchBing,
        enforceSafeSearchGoogle: defaultSettings.enforceSafeSearchGoogle,
        webMonitoringEnabled: defaultSettings.isWebMonitoringEnabled,
        safeSearch: defaultSettings.safeSearch,
        webCategory: defaultSettings.webCategory,
        webSupervisionType: 1,
      },
      timesupervison: {
        ...setRulesData?.timesupervison,

        kidId: kid.ID.toString(),
        deviceId: selectedDeviceData?.ID,
        loadDefaultSettings: defaultSettings.loadDefaultSettings,
        schedule: adjustDasyOfSchedule(defaultSettings.schedule),
        enableSupervision: defaultSettings.enableTimeSupervision,
        IsDeviceTimeSupervisionEnabled: defaultSettings.enableTimeSupervision,
        IsBlockWebAndAppEnabled: defaultSettings.blockWebAndAppEnabled ? 1 : 0,
        dailyLimitSelectedDays: {monday: 1, tuesday: 1, wednesday: 1, thursday: 1, friday: 1, saturday: 1, sunday: 1}
      },
      appsmonitoring: {
        ...setRulesData?.appsmonitoring,
        appMonitoringEnabled: defaultSettings.appMonitoringEnabled,
        appCategory: defaultSettings.appCategory
      },
      blockSettings: {
        ...setRulesData?.blockSettings,

        isSettingBlocked: defaultSettings.settingBlocked,
      },
      nudityimagecategorization: {
        ...setRulesData?.nudityimagecategorization,

        onlyNudityEnable: defaultSettings.nudityMonitoringEnable ? 1 : 0,
        detectAllNudityEnable: defaultSettings.nudityMonitoringEnable ? 1 : 0,
        deleteNudePicEnable: defaultSettings.nudityMonitoringEnable ? 1 : 0,
        screenshotNudityEnable: defaultSettings.nudityMonitoringEnable ? 1 : 0,
        blockSourceNudityEnable: defaultSettings.nudityMonitoringEnable ? 1 : 0,
      },
      callAndSmsMonitoring: {
        ...setRulesData?.callAndSmsMonitoring,

        callSmsActivate: defaultSettings.callsAndSMSMonitoringEnabled ? 1 : 0,
      },
      keystrokesmonitoring: {
        ...setRulesData?.keystrokesmonitoring,
        keystrokesdata: {
          activate: defaultSettings.enableKeyStroke || 1,
          activateNotification:
            defaultSettings.activateKeyStoreNotification || 0,
          activateScreenshot: defaultSettings.activateKeyStoreScreenshot || 0,
        },
      },
      videomonitoring: {
        ...setRulesData?.videomonitoring,
        videoMonitoringEnabled: defaultSettings.videoMonitoringEnabled
      },
      locationgeofendingsettings: {
        geoLocationEnable: defaultSettings.geoLocationEnable
      },
    };

    collectionPayload = {
      ...setRulesData,
      ...keyValuePairs
    };
    // console.log(collectionPayload);
    callFirebase(collectionPayload);

    setTimeout(() => {
      const dbPayload = {
        deviceId: selectedDeviceData?.ID,
        is_load_default_settings: 1,
        kidId: selectedKidId,
      };

      videoNudityMonitor(dbPayload)
        .then((res) => {
          // console.log(res?.data?.message);
          dispatch(
            setShowMessage({
              showMessage: true,
              defaultMessage: "Settings saved successfully",
              message: "APP_STATUS_UPDATED",
            })
          );
        })
        .catch((err) => {
          console.log(err?.response?.data?.message);
        })
        .finally(() => {
          setLoader(false);
        });
    }, 1000);
  }

  function fomattingDefaultParamaters(data = {}) {
    const tempDefaultParameter = [...defaultParameterData];
    for (const key in data) {
      tempDefaultParameter?.forEach((item, index) => {
        if (item?.key === key) {
          tempDefaultParameter[index]["value"] = data[key];
          if (key === "IsKeystrokeEndabled") {
            tempDefaultParameter[index]["KeystrokeKeywords"] =
              data["KeystrokeKeywords"];
          }
        }
      });
    }
    setDefaultParameterData(tempDefaultParameter);
    // console.log(tempDefaultParameter)
  }

  useEffect(() => {
    // console.log(device)
    if (selectedDeviceData?.ID) {
      getCollectionData(selectedDeviceData?.ID);

      setTimeout(() => {
        defaultParameter({ deviceId: selectedDeviceData?.ID })
          .then((res) => {
            // console.log("res ==>>", res)
            fomattingDefaultParamaters(res?.data?.result[0] ?? null);
            // setDefaultParameterData(res?.data?.result[0] ?? null);
          })
          .catch((err) => {
            console.log(err?.response?.data?.message);
          });
      }, 1000);
    }
  }, [selectedDeviceData?.ID]);

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  useEffect(() => {
    // to fetch the admin default setting data from firebase
    getDefaultSettingData()
      .then((res) => {
        return res;
      })
      .then((defaultData) => {
        // To fetching admin 
        const tempDefaultData = { ...defaultData };
        getDefaultSettingData("WebCategories")
          .then((webCatRes) => {
            tempDefaultData.webCategory = [...webCatRes?.categories];
          })
        getDefaultSettingData("AppCategories")
          .then((appCatRes) => {
            tempDefaultData.appCategory = [...appCatRes?.categories];
          })
        setDefaultSetting(tempDefaultData);
      })
      .catch((error) => {
        console.log("error get default setting data ==>>", error?.response?.data?.message)
      });

    // to fetch the admin default webcategories data

  }, []);

  // console.log("defaultParameterData ==>>", defaultParameterData)

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap align-items-center separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  {/* <Link to="/" className="text-blue-900 fs-5"> */}
                  <div
                    className="d-flex text-blue-900 fs-4 c-pointer"
                    onClick={() => history.goBack()}
                  >
                    <span className="">
                      <i className="icon-arrow-left" />
                    </span>
                    <h3 className="text-blue-900 mb-0">
                      {getLangTranslation(
                        "SETRULE_LOAD_DEFAULT_SETTINGS",
                        "Load default settings"
                      )}
                    </h3>
                  </div>
                  {/* </Link> */}
                </div>
              </div>
            </div>
            <div className="list-item">
              <KidImage imageUrl={kid?.image} gender={kid?.gender} />
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">{kid?.childName}</h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item col-12 col-md-3">
              <Select
                className="custom-select "
                classNamePrefix="custom-select"
                placeholder="Select Device"
                options={deviceOptions}
                value={
                  deviceOptions?.find((item) => item?.value == selectedDeviceData?.ID) || ""
                }
                onChange={(val) => {
                  setDevice(val.value);
                }}
                isSearchable={false}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="mb-6">
            <button
              className="btn btn-primary g-col-6"
              type="button"
              onClick={handleDefaultSettingToggle}
              disabled={loader}
            >
              <span className="btn-upper-case">
                {getLangTranslation(
                  "DEFAULT_SETTING_ACTIVATE_DEFAULT",
                  "Activate default settings"
                )}
              </span>
            </button>
          </div>
          <h5 className="mb-6">
            {getLangTranslation(
              "ACTIVATE_DEFAULT_SETTINGS_INFO",
              "Activating default settings will allow you to parameter your child's device to the following settings:"
            )}
          </h5>
          <div className="row">
            <div className="col-md-6">
              {defaultParameterData?.map((item, index) => {
                if (item?.value === 1 && index < 7) {
                  return (
                    <p
                      className="text-dark d-flex align-items-center gap-2 mb-6"
                      key={item?.id}
                    >
                      <i className="icon-check-round fs-5 text-success" />
                      {getLangTranslation(item?.endcodedKey, item?.text)}
                    </p>
                  );
                }
              })}
            </div>
            <div className="col-md-6">
              {defaultParameterData?.map((item, index) => {
                if (!isEmpty(item?.value) && index > 6) {
                  return (
                    <>
                      <p
                        className="text-dark d-flex align-items-center gap-2 mb-6"
                        key={item?.id}
                      >
                        {item?.key === "SetDeviceTimeSlots" && (
                          <>
                            <i className="icon-check-round fs-5 text-success" />
                            {getLangTranslation(
                              item?.endcodedKey,
                              item?.text
                            )}{" "}
                            <span className="text-blue-400">
                              {item?.value[0]}
                            </span>
                          </>
                        )}

                        {item?.key === "IsKeystrokeEndabled" && (
                          <>
                            <i className="icon-check-round fs-5 text-success" />
                            {getLangTranslation(
                              item?.endcodedKey,
                              item?.text
                            )}{" "}
                            : {item?.KeystrokeKeywords}
                          </>
                        )}

                        {(item?.key === "category" ||
                          item?.key === "AppCategory") && (
                            <>
                              <i className="icon-check-round fs-5 text-success" />
                              {getLangTranslation(item?.endcodedKey, item?.text)}
                            </>
                          )}
                      </p>
                      {(item?.key === "category" ||
                        item?.key === "AppCategory") && (
                          <ul className="text-blue-400 text-small ps-5">
                            {item?.value?.map((ele) => {
                              return (
                                <li
                                  className="mb-6"
                                  key={Math.floor(
                                    Math.random() * Math.pow(10, 5)
                                  )}
                                >
                                  {ele}
                                </li>
                              );
                            })}
                          </ul>
                        )}
                    </>
                  );
                }
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DefaultSettings;
